import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { ContentBoxContainer } from './content-box.styles';

const ContentBox = ({title, text, buttonText, whatToDo }) => {
    return (
        <ContentBoxContainer>
            <span className="header-info">
                <h2>{title}</h2>
                <p>{text}</p>
                
                {
                    buttonText ?
                        // <Link to={buttonLink} 
                        //     style={{ 
                        //         color: 'inherit',
                        //         textDecoration: 'inherit',
                        //         width: '400px',
                        //         maxWidth: '50%',
                        //         display: 'flex',
                        //         alignItems: 'center',
                        //         justifyContent: 'center'
                        // }} >
                            <Button className='button' onClick={whatToDo}>{buttonText}</Button>
                        // </Link>
                    : null
                }
            </span>
        </ContentBoxContainer>
    )
}

export default ContentBox;